<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-modal">
      <h2>Ver exames prescritos</h2>
    </div>
    @if (isLoading) {
      <app-loading-list></app-loading-list>
    }
    @if (!isLoading) {
      <div class="body-modal">
        @for (itemMedicalCare of medicalCare; track itemMedicalCare; let indexMedicalCare = $index) {
          @if (('validateGeneral' | validateThereAreExams:itemMedicalCare:isHistory:idCurrentMedicalCare)) {
            <cdk-accordion-item
              #accordionItemModule="cdkAccordionItem" class="profile-register-accordion-item" role="button" tabindex="0"
              [attr.id]="'accordion-header-' + indexMedicalCare" [attr.aria-expanded]="accordionItemModule.expanded"
              [attr.aria-controls]="'accordion-body-' + indexMedicalCare">
              <div [ngClass]="{'profile-register-accordion-item-header-expanded': accordionItemModule.expanded}"
                class="profile-register-accordion-item-header" (click)="accordionItemModule.toggle()">
                Atendimento Médico - ({{ itemMedicalCare.medicalCare.userName }} - {{
                itemMedicalCare.medicalCare.datetimeInclusion | date:'dd/MM/yy, H:mm' }})
                <span [ngClass]="{'profile-register-accordion-item-description-expanded': accordionItemModule.expanded}"
                  class="profile-register-accordion-item-description">
                  Clique para {{ accordionItemModule.expanded ? 'fechar' : 'abrir' }}
                </span>
              </div>
              <div class="profile-register-accordion-item-body" role="region"
                [style.display]="accordionItemModule.expanded ? '' : 'none'" [attr.id]="'accordion-body-' + indexMedicalCare"
                [attr.aria-labelledby]="'accordion-header-' + indexMedicalCare">
                <div class="feature-content">
                  @if (('validateIndividualList' | validateThereAreExams:itemMedicalCare:isHistory:idCurrentMedicalCare)) {
                    <div class="card-list">
                      <div class="title-header">
                        <h4>Lista de Exames</h4>
                      </div>
                      <div class="row">
                        @for (item of (itemMedicalCare | filterExamsSuspension:isHistory:idCurrentMedicalCare); track item; let indexExam = $index) {
                          @if (isHistory || (!isHistory && item.canSuspend)) {
                            <div class="col-12 col-sm-6 col-md-4">
                              <div class="card-item">
                                <div class="infos">
                                  <span [ngClass]="{'text-tacked': item.idStatus == this.sadtStatusEnum.Suspenso || (!isHistory && validateActionSuspendedExam(item.idSadtGroup))}" class="primary">{{item.typeSadtName}}</span>
                                  <span class="secundary">Uso: {{item.placeName}}</span>
                                  <span class="secundary">Status: {{item.statusName}}</span>
                                  <span class="secundary">{{item.placeName}}</span>
                                  @if (item.motiveSuspended) {
                                    <span [matTooltip]="item.motiveSuspended" class="secundary">Motivo da suspensão: {{item.motiveSuspended | truncateText:50}}</span>
                                  }
                                  @if (item.medicNameSuspended || item.nurseNameSuspended) {
                                    <span class="secundary">
                                      Responsável pela suspensão: {{item.medicNameSuspended ? item.medicNameSuspended : item.nurseNameSuspended}}; {{ item.datetimeSuspended | date:'dd/MM/yyyy HH:mm' }}
                                    </span>
                                  }
                                </div>
                                @if (!isHistory && !validateActionSuspendedExam(item.idSadtGroup)) {
                                  <div class="actions">
                                    <button>
                                      <mat-icon aria-hidden="false" aria-label="Ver mais"
                                      (click)="openExamModal(item)">block</mat-icon>
                                    </button>
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  }
                  @if (!('validateGeneral' | validateThereAreExams:itemMedicalCare:isHistory:idCurrentMedicalCare)) {
                    <app-empty-list [message]="messageEmptyListExam()"></app-empty-list>
                  }
                </div>
              </div>
            </cdk-accordion-item>
          }
        }
      </div>
    }
  </div>
</div>
<div mat-dialog-footer class="footer-modal">
  <div class="row">
    <div class="col-12 col-md-6">
      <button mat-flat-button type="button" color="accent" class=" btn-block" (click)="close()">
        @if (isLoading == false) {
          <span>Fechar</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
    @if (!isHistory) {
      <div class="col-12 col-md-6">
        <button mat-flat-button type="button" color="primary" class=" btn-block" (click)="cancel()">
          @if (isLoading == false) {
            <span>Cancelar suspensão</span>
          }
          @if (isLoading == true) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </button>
      </div>
    }
  </div>
</div>